import React from "react";

export const About = () => (
  <div className="max-w-3xl mx-auto px-6 py-10 text-left">
    <h1 className="text-3xl font-semibold mb-6 text-center">About Strongman Lifts</h1>

    <p className="mb-4">
      Strongman Lifts is a platform for browsing and analyzing strongman competition results —
      whether you want to see all-time records, or filter down to a specific weight class or
      country.
    </p>

    <p className="mb-4">
      Strongman records are difficult to find. They're often tracked on websites that get
      updated irregularly and are out of date, or they're just based on what people remember.
      Inspired by{" "}
      <a
        href="https://www.openpowerlifting.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-red-500 hover:underline"
      >
        OpenPowerlifting
      </a>
      , this site was built to make it easier to find records for athletes, whether that's all
      time or for specific weight classes or countries.
    </p>

    <p className="mb-4">
      It's not just for chasing max records — it's also meant to help you gauge yourself against
      other athletes in your weight class and/or country, and see which events you're strong at
      and where there's room for improvement.
    </p>

    <h2 className="text-xl font-semibold mt-8 mb-2">Features</h2>
    <ul className="list-disc list-inside mb-4 space-y-1">
      <li>Search and filter lifts by athlete, weight class, gender, and nationality</li>
      <li>View competition history and individual lift details</li>
    </ul>

    <h2 className="text-xl font-semibold mt-8 mb-2">Where the data comes from</h2>
    <p className="mb-4">
      Competition data is sourced from various public websites that track strongman records.
    </p>

    <h2 className="text-xl font-semibold mt-8 mb-2">What's next</h2>
    <p>
      Right now the site only covers max records for a few exercises, but there's more planned —
      including moving events, percentile standards, and individual athlete histories.
    </p>
  </div>
);
